"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTypedQueryParam = void 0;
var _getClientQueryParam = require("./getClientQueryParam");
var _getServerQueryParam = require("./getServerQueryParam");
var _isSSR = require("./isSSR");
/**
 * The Validate<T> type is used to create a conditional type.
 * This is necessary because TypeScript treats boolean as true | false,
 * but in this case, we want to allow a function that returns any boolean value (true or false), not just true or false.
 * */

/**
 * Retrieves a typed query parameter from a server-side request or a client-side URL. It is recommended to use this with enum types.
 * Validate function has higher priority than allowedValues.
 *
 * @template T The type of the query parameter's value. Must be boolean, number, or string.
 *
 * @param {string} params.name The name of the query parameter.
 * @param {(value: unknown) => T | null} [params.validate] An optional validation function for the query parameter. You can use any validation library you want, but I recommend using Zod.
 * @param {T | null} [params.fallback] An optional fallback value for the query parameter.
 * @param {IncomingMessage} [params.req] An optional HTTP request object.
 *
 * @returns {T | null} The value of the query parameter if it is present and its value is in the allowedValues array (if provided), or the fallback value (if provided), or null.
 */
const getTypedQueryParam = ({
  name,
  fallback,
  validate,
  req
}) => {
  const value = (0, _isSSR.isSSR)() && req?.url ? (0, _getServerQueryParam.getServerQueryParam)(req, name) : (0, _getClientQueryParam.getClientQueryParam)(name);
  if (value === null) {
    return fallback ?? null;
  }
  if (!validate) {
    return value;
  }
  try {
    const validatedValue = validate(value);
    if (validatedValue === null) {
      return fallback ?? null;
    }

    // as T is safe because of the validation function.
    return validatedValue;
  } catch {
    return fallback ?? null;
  }
};
exports.getTypedQueryParam = getTypedQueryParam;
//# sourceMappingURL=getTypedQueryParam.js.map